export const initialState = [];

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_FEEDBACK':
      return action.payload;
    case 'RESET_PROJECT_VIEW':
      return initialState;
    default:
      return state;
  }
};
